import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Media } from '@quorum/models/xs-resource';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sha-media-gallery-dialog',
  templateUrl: './media-gallery-dialog.component.html',
  styleUrls: ['./media-gallery-dialog.component.scss'],
})
export class MediaGalleryDialogComponent implements OnInit {
  isPopoverOpen = false;
  mediaFilterForm = this.fb.group({
    workOrderId: [null, [Validators.pattern('^[0-9]*$')]],
    appointmentId: [null, [Validators.pattern('^[0-9]*$')]],
  });
  filters$: BehaviorSubject<{ workOrderId: number; appointmentId: number }> = new BehaviorSubject<{
    workOrderId: number;
    appointmentId: number;
  }>({ workOrderId: null, appointmentId: null });
  filteredMedia$: Observable<Media[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { media$: Observable<Media[]>; showFilter: boolean },
    public dialogRef: MatDialogRef<MediaGalleryDialogComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.filteredMedia$ = combineLatest([this.data.media$, this.filters$]).pipe(
      map(([media, filters]) => {
        if (filters.workOrderId) {
          return media.filter((media) => media.tags.workOrderId === filters.workOrderId);
        } else if (filters.appointmentId) {
          return media.filter((media) => media.tags.appointmentId === filters.appointmentId);
        } else {
          return media;
        }
      })
    );
  }

  cancel() {
    this.dialogRef.close();
  }

  applyFilter(mediaFilterForm: { workOrderId: number; appointmentId: number }) {
    // Ensure only one field is submitted
    if (mediaFilterForm.workOrderId && mediaFilterForm.appointmentId) {
      this.mediaFilterForm.setErrors({ multipleFieldsSubmitted: true });
    } else {
      this.isPopoverOpen = false;
      this.filters$.next(mediaFilterForm);
    }
  }
}
